import React from 'react';

const Review = ({review}) => {
const {id,img,CustomerName,Des,rating}=review;
    return (
        <div>
             <div class="col">
    <div class="card">
      <img src={img} style={{height:'200px' , width:'200px'}} className='card-img-top m-auto rounded-circle' alt="" />
      <div class="card-body">
        <h5 class="card-title">CustomerName:{CustomerName}</h5>
        <p class="card-text">Comments:{Des}</p>
        <p class="card-text">Rating:{rating}</p>
        
      </div>
    </div>
  </div>
        </div>
    );
};

export default Review;